module.exports = __webpack_public_path__ + "static/media/sa10.d568774b.jpg";